const mediaItems = [
  {
    img: "https://readdy.ai/api/search-image?query=A%20warm%20artistic%20illustration%20of%20a%20manga%20artist%20sketching%20at%20a%20desk%20with%20warm%20lamp%20light%2C%20papers%20and%20drawing%20tools%20scattered%2C%20creative%20studio%20atmosphere%2C%20cream%20and%20sepia%20tones%2C%20Japanese%20manga%20art%20creation%20scene&width=600&height=400&seq=media-01-2026&orientation=landscape",
    title: '连载幕后：创作花絮',
    desc: '走进人气连载作者的工作室',
    tag: '创作揭秘',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20warm%20illustration%20of%20manga%20books%20and%20magazines%20displayed%20on%20wooden%20shelves%20in%20a%20cozy%20bookstore%20corner%2C%20soft%20warm%20lighting%20from%20above%2C%20cream%20and%20beige%20interior%2C%20peaceful%20reading%20atmosphere&width=600&height=400&seq=media-02-2026&orientation=landscape",
    title: '编辑推荐：本周必追',
    desc: '资深编辑精选5部连载神作',
    tag: '编辑精选',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20warm%20stylized%20illustration%20of%20a%20group%20of%20manga%20fans%20gathered%20around%20a%20table%20discussing%20comics%2C%20excited%20expressions%2C%20manga%20volumes%20on%20the%20table%2C%20cozy%20cafe%20setting%2C%20warm%20terracotta%20and%20cream%20tones&width=600&height=400&seq=media-03-2026&orientation=landscape",
    title: '读者圆桌：年度票选',
    desc: '年度最受欢迎连载作品投票',
    tag: '读者活动',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20warm%20artistic%20illustration%20of%20a%20timeline%20showing%20manga%20evolution%20from%20traditional%20paper%20to%20digital%20tablet%2C%20transition%20visualized%20with%20warm%20colors%2C%20creative%20concept%20art%2C%20cream%20and%20golden%20tones&width=600&height=400&seq=media-04-2026&orientation=landscape",
    title: '漫画进化论：纸媒到数字',
    desc: '下拉式阅读如何改变追更方式',
    tag: '行业观察',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20warm%20illustration%20of%20a%20calendar%20marked%20with%20colorful%20manga%20update%20dates%2C%20next%20to%20a%20cup%20of%20tea%20and%20reading%20glasses%20on%20a%20wooden%20desk%2C%20morning%20sunlight%2C%20organized%20and%20inviting%20atmosphere&width=600&height=400&seq=media-05-2026&orientation=landscape",
    title: '七月追更日历大盘点',
    desc: '本月最强连载更新一网打尽',
    tag: '追更日历',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精彩集锦
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            漫画世界的最新动态、幕后故事与追更指南，尽在精彩集锦
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.slice(0, 3).map((item, idx) => (
            <a
              key={idx}
              href="#index"
              className="group block bg-background-100 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden relative">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center shadow-lg transition-transform duration-300 group-hover:scale-110">
                    <i className="ri-play-fill text-xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <span className="inline-block px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-2">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5 max-w-[860px] mx-auto">
          {mediaItems.slice(3).map((item, idx) => (
            <a
              key={idx + 3}
              href="#index"
              className="group flex flex-col sm:flex-row bg-background-100 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="sm:w-2/5 aspect-[16/10] sm:aspect-auto overflow-hidden relative">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-white/90 flex items-center justify-center shadow-lg transition-transform duration-300 group-hover:scale-110">
                    <i className="ri-play-fill text-base text-primary-600 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="sm:w-3/5 p-4">
                <span className="inline-block px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-2">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}